import moment from 'moment';
import { Button } from 'primereact/button';
import { useMemo } from 'react';
import Tag from '../../../../components/Display/Tag';
import { getConstant } from '../../../../utils/constants';
import { getImage } from '../../../../utils/imageHelper';
import { Star, Pin, UsersRound } from 'lucide-react';
import styles from "../../cards.module.scss"

function EventItem({ event, handleClickEvent, handleDuplicateEvent, layout }) {
  const isMultipleDay = useMemo(
    () => moment(event.start_dt).format('L') !== moment(event.end_dt).format('L'),
    [event]
  );

  return (
    <div
      className={`${styles.projectCard} ${layout === "grid" ? styles.projectCardGrid : ''}`}
      onClick={handleClickEvent}>
      <img
        className={styles.projectImage}
        src={event.image ? event.image.file : getImage('img-ph.png')}
        alt={event.image ? event.image.label : 'Non renseignée'}
      />
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{event.title}</p>
          <span className={styles.subtitle}>
            {moment(event.start_dt).format(isMultipleDay ? 'll' : 'lll')}

            {event.end_dt && (
              <>
                {' - '}
                {moment(event.end_dt).format(isMultipleDay ? 'll' : 'LT')}
              </>
            )}
          </span>

        </div>
        <div className={styles.tagList}>
          <Tag
            tag={{
              label: getConstant('shared.draftTypes', event.is_draft).label,
              bgColor: getConstant('shared.draftTypes', event.is_draft).bgColor
            }}
          />
          <Tag
            tag={{
              label: getConstant('bassecour.type', event.type).label,
              icon: Star,
              bgColor: 'bg-sky-950'
            }}
          />
          <Tag
            tag={{
              label: event.place?.label,
              icon: Pin,
              bgColor: 'bg-green-800'
            }}
          />
          <Tag
            tag={{
              label: getConstant('bassecour.main_tag', event.main_tag).label,
              icon: UsersRound,
              bgColor: 'bg-orange-800'
            }}
          />
        </div>
      </div>
      <Button
        rounded
        icon="pi pi-clone"
        className={styles.button}
        tooltip="Dupliquer l'évènement"
        tooltipOptions={{ position: 'left' }}
        onClick={handleDuplicateEvent}
        severity="secondary"
        outlined
      />
    </div>

  );
}

export default EventItem;
